module.exports = __webpack_public_path__ + "img/menu-heart-large.fb5933e.svg";